import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import MonitorService from 'src/controllers/MonitorService';
import { PieChart, Series, Connector, Legend, Animation, Label, Font } from 'devextreme-react/pie-chart';
import { selectionTypes } from 'src/components/utils/consts';
import WidgetSettings from 'src/components/dashboard/widgets/widgetsettings';

const PieRenderer = React.memo(({ campaigns, rtl, customizeText }) => {

    return <PieChart
        id="campaignsstatus"
        dataSource={campaigns}
        type="doughnut"
        resolveLabelOverlapping="shift"
        redrawOnResize
        rtlEnabled={rtl}
    >
        <Series argumentField="name" valueField="occurrences">
            <Font size={16} />
            <Label visible={true} customizeText={customizeText}>
                <Connector visible={true} width={1} />
            </Label>
        </Series>
        <Legend visible={false}></Legend>
        <Animation enabled={true}></Animation>
    </PieChart>

}, (prevProps, nextProps) => {
    return (
        prevProps.rtl === nextProps.rtl &&
        JSON.stringify(prevProps.campaigns) === JSON.stringify(nextProps.campaigns)
    );
});
class UserCampaignStatus extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showSettings: false,
            groupId: -1,
            campaignName: "",
            campaigns: []
        };

        this.updateState = this.updateState.bind(this);
        this.setCampaign = this.setCampaign.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
        this.customizeText = this.customizeText.bind(this);
    }


    componentDidMount() {
        let groupId = parseInt(localStorage.getItem(`UserCampaignStatus_groupId_${this.props.userId}`) || -1);
        let campaignName = localStorage.getItem(`UserCampaignStatus_campaignName_${this.props.userId}`) || this.props.t("all2");
        this.setState({
            groupId: groupId,
            campaignName: campaignName
        });
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.subscribe(`/user/${this.props.token}/topic/usercampaignsstatus_${this.props.userId}/`, this.updateState, { id: `usercampaignsstatus_${this.props.userId}` });

            MonitorService.stompClient.send("/app/subscribe/usercampaignsstatus", {}, JSON.stringify({
                token: this.props.token,
                widgetId: this.props.userId,
                groupId: groupId
            }));
        }

    }

    componentWillUnmount() {
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send(`/user/topic/usercampaignsstatus/`, {}, JSON.stringify({ token: this.props.token }));
            MonitorService.stompClient.unsubscribe(`usercampaignsstatus_${this.props.userId}`);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        let ret = false;
        if (JSON.stringify(nextState.campaigns) !== JSON.stringify(this.state.campaigns) || nextState.showSettings !== this.state.showSettings) {
            ret = true;
        }
        return ret;
    }

    updateState(campData) {
        var data = JSON.parse(campData.body);
        this.setState({
            campaigns: data
        });
    }

    setCampaign = (groupId, campaignName) => {

        this.setState({
            groupId: groupId,
            campaignName, campaignName,
            showSettings: !this.state.showSettings
        });

        localStorage.setItem(`UserCampaignStatus_groupId_${this.props.userId}`, groupId);
        localStorage.setItem(`UserCampaignStatus_campaignName_${this.props.userId}`, campaignName);
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/usercampaignsstatus", {}, JSON.stringify({
                token: this.props.token,
                groupId: groupId,
                widgetId: this.props.userId,
            }));
        }

    };

    toggleSettings() {
        this.setState({
            showSettings: !this.state.showSettings
        });
    }

    customizeText(arg) {
        let text = this.props.t(arg.argumentText) || arg.argumentText;
        return `${arg.valueText} (${arg.percentText}) ${text}`;
    }

    render() {
        return (<div className='position-relative' style={{ top: 10 }}>

            <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} style={{ width: "100%", height: "100%", margin: "0px" }}>
                <div className="card-header drag-handle">
                    <h3 className="card-title align-items-start flex-column text-primary">
                        <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("magnifying-glass-chart")} /> {this.props.t("campaignsstatus")} - {this.state.campaignName}</span>
                    </h3>
                    <div className="card-toolbar" style={{ zIndex: 1000 }}>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("config")}
                            </Tooltip>}>
                            <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={this.toggleSettings} >
                                <FontAwesomeIcon icon={duotone("grid-2")} />
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="card-body" style={{ padding: "0px", height: "90%" }} >
                    <PieRenderer customizeText={this.customizeText} campaigns={this.state.campaigns} rtl={this.props.rtl} />
                </div>

            </div>
            <WidgetSettings showSettings={this.state.showSettings} toggleSettings={this.toggleSettings}
                token={this.props.token} setCampaign={this.setCampaign} groupId={this.state.groupId}
                campaignName={this.state.campaignName} selectionType={selectionTypes.CAMPAIGN}></WidgetSettings>
        </div>)
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        rtl: state.parameters.rtl
    };
};

export default compose(connect(mapStateToProps, null), withTranslation())(UserCampaignStatus);